var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('img',{staticClass:"shareledger-kyc-checked",attrs:{"src":"/icons/check-circle-2.svg"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }